(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
// Growl
'use strict';

function Growl() {

    function make(message, type) {

        if (typeof message.responseText != 'undefined' && type == 'danger') {

            var errors = JSON.parse(message.responseText);

            message = parseErrors(errors.message);

            return render(message, type);
        }

        if (_.isArray(message)) {
            message = message.join("<br/>");
        }

        return render(message, type);
    }

    function parseErrors(e) {

        var errors = [];

        _.each(e, function (v, k) {

            $(k).addClass('error');

            errors.push(v[0]);
        });

        return errors.join("<br/>");
    }

    function render(message, type) {

        return $.bootstrapGrowl(message, {
            ele: 'body', // which element to append to
            type: type, // (null, 'info', 'danger', 'success')
            width: 300,
            offset: { from: 'top', amount: 20 }
        });
    }

    return {
        make: make
    };
}

module.exports = new Growl();
window.growl = new Growl();

},{}],2:[function(require,module,exports){
'use strict';

var Auth = require('./../../services/Auth');
var Growl = require('./../../helpers/Growl');
var Forgot = function Forgot() {
	this.form = '#forgot-form';
};
Forgot.prototype = {
	initialize: function initialize() {
		jQuery(this.form).on('submit', this.submitHandler.bind(this));
	},
	submitHandler: function submitHandler(e) {
		e.preventDefault();
		jQuery('.login-action').text("Please Wait...");
		Auth.forgot(jQuery('#email').val()).done(function () {
			toastr.success('Reset password instruction has been sent to your email');
			// Growl.make(["Reset password instruction has been sent to your email"], 'success');
			setTimeout(function () {
				window.location.href = '/auth/login';
			}, 3000);
		}).fail(function (response) {
			jQuery('.login-action').text("Resend");
			toastr.error('The selected email is invalid');
		});
	}
};

module.exports = new Forgot();

},{"./../../helpers/Growl":1,"./../../services/Auth":7}],3:[function(require,module,exports){
'use strict';

var Login = require('./login');
var ResetPassword = require('./reset');
var Forgot = require('./forgot');
var Register = require('./register');

Login.initialize();
ResetPassword.initialize();
Forgot.initialize();
Register.initialize();

},{"./forgot":2,"./login":4,"./register":5,"./reset":6}],4:[function(require,module,exports){
'use strict';

var Auth = require('./../../services/Auth');
var Growl = require('./../../helpers/Growl');
var Login = function Login() {
	this.form = '#login-form';
};
Login.prototype = {
	initialize: function initialize() {
		jQuery(this.form).on('submit', this.submitHandler.bind(this));
	},
	submitHandler: function submitHandler(e) {
		e.preventDefault();
		jQuery('.login-action').text("Signing In...");
		Auth.login(jQuery('#email').val(), jQuery('#password').val()).done(function () {
			var sub_id = jQuery('#sub_id').val();
			var code = jQuery('#code').val();
			if (sub_id) {
				window.location.href = '/order/payment?sub_id=' + sub_id;
			} else if (code) {
				window.location.href = '/account/signup-freetrial?code=' + code;
			} else {
				window.location.href = '/account';
			}
		}).fail(function (response) {
			jQuery('.login-action').text("Sign In");
			// console.log(response);
			// // Growl.make(response, 'danger');
			// var messages = '';
			// _.each(response.responseJSON.message, function(str) {
			// 	messages += str + "<br/>";
			// });
			// toastr.error(messages);
		});
	}
};

module.exports = new Login();

},{"./../../helpers/Growl":1,"./../../services/Auth":7}],5:[function(require,module,exports){
///////////////////////////
// Register MODULE
//////////////////////////
'use strict';

var Auth = require('./../../services/Auth');
var Growl = require('./../../helpers/Growl');
var Register = function Register() {
        this.form = '#register-form';
};
Register.prototype = {
        initialize: function initialize() {
                jQuery(this.form).on('submit', this.submitHandler.bind(this));
        },
        submitHandler: function submitHandler(e) {
                e.preventDefault();
                Auth.register({
                        email: jQuery('#email').val(),
                        username: jQuery('#username').val(),
                        password: jQuery('#password').val(),
                        password_confirmation: jQuery('#password_confirmation').val()
                }).done(function (data) {
                        window.location.href = '/account';
                }).fail(function (error) {
                        $('.register-error').fadeIn();
                        var messages = '';
                        _.each(error.responseJSON.message, function (str) {
                                messages += str + "<br/>";
                        });
                        $('#register-error-messages').html(messages);
                        // jQuery('.login-action').text("Sign In");
                        // Growl.make(response, 'danger');
                });
        }
};

module.exports = new Register();

},{"./../../helpers/Growl":1,"./../../services/Auth":7}],6:[function(require,module,exports){
'use strict';

var Auth = require('./../../services/Auth');
var Growl = require('./../../helpers/Growl');
var ResetPassword = function ResetPassword() {
	this.form = '#reset-form';
};
ResetPassword.prototype = {
	initialize: function initialize() {
		jQuery(this.form).on('submit', this.submitHandler.bind(this));
	},
	submitHandler: function submitHandler(e) {
		e.preventDefault();
		jQuery('.login-action').text("Please Wait...");
		Auth.reset({
			code: jQuery('#code').val(),
			uid: jQuery('#uid').val(),
			password: jQuery('#password').val(),
			password_confirmation: jQuery('#password_confirmation').val()
		}).done(function () {
			// Growl.make(["Password has been successfully reset."], 'success');
			toastr.success('Password has been successfully reset');
			setTimeout(function () {
				window.location.href = '/auth/login';
			}, 3000);
		}).fail(function (responseText) {
			// console.log(response);
			jQuery('.login-action').text("Try Again");
			toastr.error('The password confirmation does not match');
		});
	}
};

module.exports = new ResetPassword();

},{"./../../helpers/Growl":1,"./../../services/Auth":7}],7:[function(require,module,exports){
'use strict';

var Auth = function Auth() {};

Auth.prototype = {
	login: function login(email, password) {
		var deferred = $.Deferred();
		$.ajax({
			type: 'POST',
			url: '/auth/login',
			data: { email: email, password: password },
			success: function success(data) {
				deferred.resolve(data.data);
			},
			error: function error(response) {
				deferred.reject(response);
			}
		});
		return deferred.promise();
	},
	forgot: function forgot(email) {
		var deferred = $.Deferred();
		$.ajax({
			type: 'POST',
			url: '/auth/forgot',
			data: { email: email },
			success: function success(data) {
				deferred.resolve(data.data);
			},
			error: function error(response) {
				deferred.reject(response);
			}
		});
		return deferred.promise();
	},
	reset: function reset(data) {
		var deferred = $.Deferred();
		$.ajax({
			type: 'POST',
			url: '/auth/reset',
			data: data,
			success: function success(data) {
				deferred.resolve(data.data);
			},
			error: function error(response) {
				deferred.reject(response);
			}
		});
		return deferred.promise();
	},
	register: function register(credentials) {
		var deferred = $.Deferred();
		$.ajax({
			type: 'POST',
			url: '/auth/register',
			data: credentials,
			success: function success(data) {
				deferred.resolve(data.data);
			},
			error: function error(response) {
				deferred.reject(response);
			}
		});
		return deferred.promise();
	}
};

module.exports = new Auth();

},{}]},{},[3]);
